import { useDateFormatter, useTranslations } from "../../contexts/Translation";
import { GoalPhase } from "./phases";
import styles from "./Details.module.css";

const labels = { planning: "phasesInitial", execution: "phasesExec", conclusion: "phasesConclusion" };
const texts = { planning: "phasePlanningText", execution: "phaseExecutionText", conclusion: "phaseConclusionText" };

type GoalPhasesProps = {
  phases: GoalPhase[];
  progress: number;
  conclusionOpen: boolean;
};

const GoalPhases = ({ phases, progress, conclusionOpen }: GoalPhasesProps) => {
  const t = useTranslations("improvementGoals");
  const d = useDateFormatter();
  const x = (i: number) => 8 + i * 92;

  return (
    <section className={styles.phases} aria-label={t("phasesHeading")}>
      <svg className={styles.journey} aria-hidden='true' viewBox='0 0 200 16' preserveAspectRatio='none'>
        <line x1={x(0)} x2={x(2)} y1='8' y2='8' stroke='var(--color-muted)' strokeWidth='4' strokeLinecap='round' />
        <line x1={x(0)} x2={x(0) + (x(2) - x(0)) * progress} y1='8' y2='8' stroke='var(--color-cta)' strokeWidth='4' strokeLinecap='round' />
      </svg>
      <ol className={styles.phaseList}>
        {phases.map((p) => (
          <li key={p.key} className={[styles.phase, styles[p.state]].join(" ")} aria-current={p.state === "active" ? "step" : undefined}>
            <span className={styles.dot} aria-hidden='true' />
            <strong>{t(labels[p.key])}</strong>
            <span className={styles.phaseDates}>
              {d(p.from)} – {d(p.to)}
            </span>
            <span className={styles.phaseText}>{p.key === "conclusion" && !conclusionOpen ? t("patienceConclusion") : t(texts[p.key])}</span>
          </li>
        ))}
      </ol>
    </section>
  );
};

export default GoalPhases;
